import { Box } from '@mui/material';
import Typography from '@ui/Typography';
import React from 'react';
import CircularLoader from 'components/LoadingIndicators/CircularLoader';

const SmartSuggestionsLoading = () => {
  return (
    <Box
      flex={1}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      style={{ gap: 16 }}
    >
      <CircularLoader size={64} />
      <Typography variant="pSm">{`Finding suggestions`}</Typography>
    </Box>
  );
};

export default SmartSuggestionsLoading;
